import { createSlice } from '@reduxjs/toolkit';
import { LibroResponse, getLibros, getLibrosById, LibroData, PrecioEnvioResponse, getPreciosEnvio } from './librosActions';
 
interface InitialState {
  itemsSuccess: boolean;
  itemsData: undefined | LibroResponse;
  itemsLoading: boolean;
  itemsError: boolean;

  itemIdSuccess: boolean;
  itemIdData: undefined | LibroData;
  itemIdLoading: boolean;
  itemIdError: boolean;

  preciosEnvioData: undefined | PrecioEnvioResponse;
  preciosEnvioLoading: boolean;
}

const initialState: InitialState = {
  itemsSuccess: false,
  itemsData: undefined,
  itemsLoading: false,
  itemsError: false,

  itemIdSuccess: false,
  itemIdData: undefined,
  itemIdLoading: false,
  itemIdError: false,

  preciosEnvioData: undefined,
  preciosEnvioLoading: false,
};

const LibrosSlice = createSlice({
  name: 'Libros',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getLibros.rejected, (state: InitialState) => {
      state.itemsError = true;
      state.itemsLoading = false;
      state.itemsSuccess = false;
      state.itemsData = undefined;
    });
    builder.addCase(getLibros.pending, (state: InitialState) => {
      state.itemsError = false;
      state.itemsLoading = true;
      state.itemsSuccess = false;
    });
    builder.addCase(getLibros.fulfilled, (state: InitialState, action) => {
      state.itemsData = action.payload;
      state.itemsError = false;
      state.itemsLoading = false;
      state.itemsSuccess = true;
    });

    builder.addCase(getLibrosById.rejected, (state: InitialState) => {
      state.itemIdError = true;
      state.itemIdLoading = false;
      state.itemIdSuccess = false;
      state.itemIdData = undefined;
    });
    builder.addCase(getLibrosById.pending, (state: InitialState) => {
      state.itemIdError = false;
      state.itemIdSuccess = true;
      state.itemIdLoading = false;
    });
    builder.addCase(getLibrosById.fulfilled, (state: InitialState, action) => {
      state.itemIdData = action.payload;
      state.itemIdError = false;
      state.itemIdSuccess = false;
      state.itemIdLoading = true;
    });

    builder.addCase(getPreciosEnvio.pending, (state: InitialState) => {
      state.preciosEnvioLoading = true;
    });
    builder.addCase(getPreciosEnvio.fulfilled, (state: InitialState, action) => {
      state.preciosEnvioData = action.payload;
      state.preciosEnvioLoading = false;
    });
    builder.addCase(getPreciosEnvio.rejected, (state: InitialState) => {
      state.preciosEnvioLoading = false;
    });
   
  },
});

export default LibrosSlice.reducer;
 